import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'
import { ISystemLogs } from '@/features/system-logs/systemLogsSlice';

export const getSystemLogs = async (params?: any): Promise<IApiResponse<IList<ISystemLogs>>> => {
	const { data } = await axios.get<IApiResponse<IList<ISystemLogs>>>('/api/system-logs', { params })
	return data
}